import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";

import {
  CreditsBalanceResponse,
  CreditsKeys,
  getCreditsBalance,
} from "../api/credits";

export function useCredits() {
  const { isAuthenticated } = useAuth0();

  const { data, isLoading } = useQuery<CreditsBalanceResponse>({
    queryKey: [CreditsKeys.Balance],
    queryFn: getCreditsBalance,
    enabled: isAuthenticated,
  });

  return {
    balance: data?.balance ?? 0,
    totalGranted: data?.totalGranted ?? 200,
    creditsUsed: data ? data.totalGranted - data.balance : 0,
    resetDate: data?.resetDate,
    isLoading,
  };
}
